module.exports = __webpack_public_path__ + "static/media/mu.645d3f9b.svg";